export default {
  PAYMENT_MANAGEMENT_INFO_LIST_REQUEST: 'APP/PAYMENT_MANAGEMENT_INFO/PAYMENT_MANAGEMENT_INFO_REQUEST',
  PAYMENT_MANAGEMENT_INFO_LIST_SUCCESS: 'APP/PAYMENT_MANAGEMENT_INFO/PAYMENT_MANAGEMENT_INFO_SUCCESS',
  PAYMENT_MANAGEMENT_INFO_LIST_ERROR: 'APP/PAYMENT_MANAGEMENT_INFO/PAYMENT_MANAGEMENT_INFO_ERROR',
};
